import CommonCard from "../ui/CommonCard/CommonCard";
import SearchInput from "../ui/SearchInput/SearchInput";
import classes from "./ReusableTable.module.css";

const ReusableTable = ({
  data = [],
  columns = [],
  loading = false,
  searchTerm,
  setSearchTerm,
  onRowClick,
  page = 1,
  limit = 10,
  count = 0,
  totalPages = 1,
  setPage,
}) => {
  return (
    <CommonCard className={classes.customCard}>
      {/* Search */}
      {setSearchTerm && (
        <div className="mb-3">
          <SearchInput
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      )}

      {/* Table */}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className={classes.table}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((row, idx) => (
                <tr
                  key={row._id || idx}
                  onClick={() => onRowClick && onRowClick(row)}
                  style={{ cursor: onRowClick ? "pointer" : "default" }}
                >
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      className={col.className || ""}
                    >
                      {col.render ? col.render(row[col.key], row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length}>No data found</td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {/* Footer / Pagination */}
      <div className={classes.footer}>
        <span>
          {data.length > 0
            ? `${(page - 1) * limit + 1} - ${(page - 1) * limit + data.length} of ${count} items`
            : "0 items"}
        </span>
        <div>
          <button
            className={classes.pageBtn}
            disabled={page === 1}
            onClick={() => setPage && setPage((prev) => prev - 1)}
          >
            Previous
          </button>
          <button
            className={classes.pageBtn}
            disabled={page === totalPages}
            onClick={() => setPage && setPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </CommonCard>
  );
};

export default ReusableTable;